enum EFeatureFlags {
  EXTERNAL_PO = 'EXTERNAL_PO',
  CRIBS_BINS = 'CRIBS_BINS',
  SUPPLIERS = 'SUPPLIERS',
  ITEM_CATALOG = 'ITEM_CATALOG',
  TRANSACTIONS = 'TRANSACTIONS',
  RESTRICTIONS = 'RESTRICTIONS',
  MANAGE_GROUPS = 'MANAGE_GROUPS',
  REPORTS = 'REPORTS',
  INSIGHTS = 'INSIGHTS',
  USERS = 'USERS',
  COST_CENTERS = 'COST_CENTERS',
  ORGANIZATIONS = 'ORGANIZATIONS',
  CRIBS = 'CRIBS',
  BINS = 'BINS',
  USER_GROUPS = 'USER_GROUPS',
  CRIB_GROUPS = 'CRIB_GROUPS',
  SCHEDULING = 'SCHEDULING',
  DURABLE_RETURNS = 'DURABLE_RETURNS',
  CUSTOMERS = 'CUSTOMERS',
  BAR_CODE = 'BAR_CODE',
}

export { EFeatureFlags };
